var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgShareYourShopIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.1 7.59743H9.55007C8.50074 7.59743 7.65009 8.44808 7.65009 9.49742V18.0474C7.65009 19.0967 8.50074 19.9474 9.55007 19.9474H18.1C19.1494 19.9474 20 19.0967 20 18.0474V9.49742C20 8.44808 19.1494 7.59743 18.1 7.59743Z",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3.84998 13.2973H2.89999C2.39608 13.2973 1.91281 13.0971 1.55649 12.7408C1.20018 12.3845 1 11.9012 1 11.3973V2.84735C1 2.34344 1.20018 1.86017 1.55649 1.50385C1.91281 1.14753 2.39608 0.947357 2.89999 0.947357H11.4499C11.9538 0.947357 12.4371 1.14753 12.7934 1.50385C13.1497 1.86017 13.3499 2.34344 13.3499 2.84735V3.79734",
    stroke: "#2B2B2B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareYourShopIcon);
export default __webpack_public_path__ + "static/media/share-your-shop-icon.e6a8027761fd7490dd5384575c51a131.svg";
export { ForwardRef as ReactComponent };